import React, { memo, useCallback } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { t } from 'utils/getLiteral';
import './styles.scss';

const CrudCheckbox = memo(({ input, onChange, label = '', readOnly }) => {
    const classNames = classnames('custom-control-label', {
        'custom-control-input__disabled': readOnly,
    });

    const onChangeCheckbox = useCallback(
        (el) => {
            input.onChange(el.target.checked);
            onChange && onChange(el.target.checked);
        },
        [input, onChange],
    );

    return (
        <div className="custom-control custom-checkbox custom-checkbox-crud">
            <input
                className="custom-control-input"
                type="checkbox"
                checked={input.value === true}
                id={input.name}
                name={input.name}
                onChange={onChangeCheckbox}
                disabled={readOnly}
            />
            <label className={classNames} htmlFor={input.name}>
                {t(label)}
            </label>
        </div>
    );
});

CrudCheckbox.propTypes = {
    input: PropTypes.shape({}).isRequired,
    label: PropTypes.string,
};

export default CrudCheckbox;
